(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/draws/assets/javascripts/services/fetch-all-draws.js') >= 0) return;  svs.modules.push('/components/marketplace-data/draws/assets/javascripts/services/fetch-all-draws.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const helpers = svs.components.marketplaceData.draws.helpers;
const _svs$racing$common$co = svs.racing.common.constants,
  gameTypeToSubProductId = _svs$racing$common$co.gameTypeToSubProductId,
  gameTypes = _svs$racing$common$co.gameTypes;
const productResolver = svs.utils.products;
const getProdName = svs.components.lbUtils.sportProducts.getProdName;
const ApiProxy = svs.components.lbUtils.apiProxy.ApiProxy;
const topptipset = getProdName(productResolver.productIds.T8);
const getDrawUrl = product => {
  const productMapper = {
    [topptipset]: 'topptipsetfamily'
  };

  const apiMapper = {
    hastar: "/racing/1/racecard/product/".concat(gameTypeToSubProductId[gameTypes.TOPP5], "?includeDefined=true")
  };
  product = productMapper[product] || productResolver.getDrawName(product) || product;
  const api = apiMapper[product] || "/draw/1/".concat(product, "/draws/light?include=").concat(encodeURIComponent(helpers.drawInclude('draws', {
    excludeEvents: true
  })));
  return api;
};
const fetchAllDraws = async (productList, callback) => {
  try {
    const apiProxy = ApiProxy.create();
    const productDrawPromises = productList.map(product => {
      const url = getDrawUrl(product.toLowerCase());
      try {
        return apiProxy.fetch(url, {
          method: 'GET'
        });
      } catch (error) {
        return Promise.reject(error);
      }
    });
    const settledResponses = await Promise.allSettled(productDrawPromises);
    const productsWithDraws = {};
    for (const _ref of settledResponses.entries()) {
      var _ref2 = _slicedToArray(_ref, 2);
      const index = _ref2[0];
      var _ref2$ = _ref2[1];
      const status = _ref2$.status;
      const value = _ref2$.value;
      const reason = _ref2$.reason;
      const product = productList[index];
      if (status === 'rejected') {
        productsWithDraws[product] = {
          draws: [],
          error: reason
        };
        continue;
      }
      const drawFilter = draw => draw.drawStateId === 2;
      const drawNormalizer = draw => helpers.normalizeDraw(draw);
      const isRacing = productResolver.helpers.isRacing(product);
      productsWithDraws[product] = isRacing ? helpers.normalizeRaceMarketplace(value) : {
        draws: value.draws.filter(drawFilter).map(drawNormalizer)
      };
    }

    for (const productIdentifier of Object.keys(productsWithDraws)) {
      const product = productsWithDraws[productIdentifier];
      product.draws = product.draws.filter(draw => draw.regCloseTime >= new Date());
      if (productResolver.helpers.isRacing(productIdentifier)) {
        const meetingIds = new Set();
        const raceIds = new Set();
        for (const draw of product.draws) {
          meetingIds.add(product.races[draw.raceId].meetingId);
          raceIds.add(draw.raceId);
        }
        const meetingIdsToKeep = Object.keys(product.meetings).filter(meetingId => meetingIds.has(Number(meetingId)));
        const meetings = {};
        for (const meetingId of meetingIdsToKeep) {
          meetings[meetingId] = product.meetings[meetingId];
        }
        product.meetings = meetings;
        const raceIdsToKeep = Object.keys(product.races).filter(raceId => raceIds.has(Number(raceId)));
        const races = {};
        for (const raceId of raceIdsToKeep) {
          races[raceId] = product.races[raceId];
        }
        product.races = races;
      }
    }
    const _sortByTimeAsc = list => list.sort((a, b) => new Date(a.regCloseTime).getTime() - new Date(b.regCloseTime).getTime());
    Object.keys(productsWithDraws).forEach(key => _sortByTimeAsc(productsWithDraws[key].draws));
    callback(undefined, productsWithDraws);
  } catch (error) {
    callback(error);
  }
};
setGlobal('svs.components.marketplaceData.draws.services.fetchAllDraws', fetchAllDraws);

 })(window);